module.exports = __webpack_public_path__ + "img/zombie_psr.6727ae76.jpg";